<template>
  <SideNav />




  <header>
    <div
      class="page-header min-vh-50 "
      style="background-image: url('assets/img/tronbmms1.jpg');"
    >
      <span class="mask bg-black opacity-5" />
    </div>
    <div class="position-relative">                    
      <div class="position-absolute w-md-60 z-index-3  d-md-none bottom-80">
        <img
          class="img-fluid px-4"
          src="assets/img/tronbmms2.png"
        >
      </div> 
      <div class="container px-md-0 position-relative">        
        <div class="col-12 col-xl-7 position-md-absolute end-0 top-n25 w-md-70 order-1 order-md-2  z-index-3  d-none d-md-block move-on-hover">
          <img
            class="w-100"
            src="assets/img/tronbmms2.png"
            alt="macbook"
            loading="lazy"
          >
        </div>
        <div class="bg-gradient-success position-relative pt-5 pb-4 py-md-3 py-lg-4  z-index-2 border-radius-xl mt-n7 mt-sm-n10 mt-md-n12  overflow-hidden">
          <img
            src="assets/img/shapes/pattern-lines.svg"
            alt="pattern-lines"
            class="position-absolute opacity-6 start-0 top-0 w-100"
            loading="lazy"
          >
          <div class="px-3 px-md-5 position-relative">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-xl-5 text-center text-md-start  position-relative order-2 order-md-1 pt-4 py-sm-5">
                <div class="position-relative">
                  <h3 class="text-white mt-sm-0 mb-3">
                    TronMap<br class="d-none d-md-block d-lg-none">創益圖
                  </h3>
                  <p class="text-white mb-3">
                    智慧園區<br>園區地圖導覽<br>創益Security
                  </p>
                  <button
                    type="button"
                    class="btn bg-gradient-dark btn-lg me-3 mt-3"
                  >
                    <i class="material-icons me-2">menu_book</i>技術支援
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>


  <div class="py-5 pt-lg-0 pb-lg-6 container px-0">
    <div class="p-3 info-hoversuccess text-center mb-4 mt-md-6">
      <div class="icon icon-shape bg-gradient-success shadow icon-shape-circle text-success">
        <i
          class="fa fa-cube  opacity-10"
          aria-hidden="true"
        />
      </div>
    </div>
    <h4 class="mb-4 text-center mb-6">
      Tron Map 創益圖產品介紹
    </h4>
    <div class="row align-items-center mx-0">
      <div class="mx-auto col-md-6 order-2 order-md-1">
        <p class="text-dark lh-lg">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  創益圖 TronMap v2.0 搶先版的主平台 BMMS 是一套用於雲端園區建築繪圖與園區建築管理的系統，使用昀揚科技自製研發的「園區建築繪圖動畫引擎」，結合「園區建築物管理系統」與「園區建築繪圖系統」等多項專利技術，可在衛星地圖上繪製建築物件並且管理樓層、室內空間、公共空間、設備圖示、設施圖標、警示、通知、導覽內容、動態訊息等屬性內容，繪圖的過程會將所有繪圖物件的衛星座標同步儲存在雲端資料庫（座標精準度達小數點 14 位），主要可以應用在智慧園區、園區地圖導覽、元宇宙、AIOT設備資訊、ESG、資產管理、資安 SOC 監控管理、違規取締等服務。
        </p>
      </div>
      <div class="col-md-6 order-1 order-md-2 mb-5 mb-md-0 ms-auto">
        <img
          src="assets/img/bmms23.jpg"
          class="img-fluid rounded shadow-lg"
        >
      </div>
    </div>

    <section class="pt-5 pt-lg-4">
      <div class="container px-0">
        <div class="">
          <div class="col-lg-8 ms-auto me-auto text-center">
            <div class="p-3 info-hover-warning mb-4">
              <div class="icon icon-shape bg-gradient-success shadow icon-shape-circle text-success">
                <i
                  class="fa fa-network-wired opacity-10"
                  aria-hidden="true"
                />
              </div>
            </div>
            <h4 class="card-title mb-4">
              <a class="text-dark">產品規格</a>
            </h4>
            <p class="card-description  mb-4">
              TronMap v2.0 搶先版有六大平台系統，主平台為園區建築管理平台（BMMS），可加購智慧園區平台（IPP）、園區地圖導覽平台（PMN）、
              創益 Security 平台（TronSecurity），與計劃在2025年推出正式版並開放選購的智能繪圖助理平台（ADP）、智能繪圖助理訓練平台（ADTP）等平台，使用者可彈性選擇軟體授權或訂閱制方案。
            </p>
          </div>
        </div>


        <div class="row align-items-center mx-0 mb-5">
          <div class="col-xl-6 mb-5">
            <img
              src="assets/img/bmms22.jpg"
              class="img-fluid rounded shadow-lg"
            >
          </div>            
          <div class="col-xl-6 mt-lg-0 mt-5 ps-lg-0 ps-0">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div> 
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-spell-check opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3"> 
                  <h5 class="mb-0 ">
                    園區建築管理平台
                  </h5>
                  <span class="text-normal  text-info">BMMS Platform</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    分別有園區管理模組、衛星地圖模組、建築設施管理模組、物件管理模組、動態訊息模組、快速鍵模組及「園區建築繪圖動畫引擎」開發的建築設施物件模組、物件圖層模組、園區畫布模組、建築設施繪圖模組、建築空間繪圖模組、園區導覽模組、渲染列印匯出模組。
                  </li>
                </ul>
              </div>
            </div>              
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div> 
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-photo-film-music opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    智慧園區平台
                  </h5>                
                  <span class="text-normal  text-info">Intelligence Park Platform</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    智慧園區戰情中心：管理園區 AIOT、設施、設備、資安、資產並提供風險、警示、事件、通知、追蹤等服務，可連結地圖導覽模式使用上帝視角瀏覽園區，提供更全面與多元的智慧園區管理操作體驗。
                  </li>
                </ul>
              </div>
            </div>
          </div>        
        </div>
        <div class="row align-items-center mx-0 mb-6">
          <div class="col-lg-5  order-2 order-lg-1">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-laptop-file opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    園區地圖導覽平台
                  </h5>                
                  <span class="text-normal  text-info">Park Map Navigation Platform</span>
                </div>
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    在地圖座標位置上，顯示建築物、公共空間、室內空間、設備、設施等物件及智能園區相關資訊。
                  </li>
                </ul>
              </div>
            </div> 
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-cloud-question opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    創益 Security 平台
                  </h5>                
                  <span class="text-normal  text-info">TronSecurity Platform</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    與工研院技術合作推出 FIDO2、MFA 等模組快速部署零信任架構 ( ZTA )
                  </li>
                </ul>
              </div>
            </div> 
          </div>     
          <div class="mx-auto col-lg-7 order-1 order-lg-2  mb-5 mb-lg-0">
            <img
              src="assets/img/bmms25.jpg"
              class="img-fluid "
            >
          </div> 
        </div>
        <div class="row align-items-center mx-0 mb-5">
          <div class="mx-auto col-md-6 mb-4 mb-lg-0 pe-lg-4">
            <img
              src="assets/img/bmms24.jpg"
              class="img-fluid rounded shadow-lg"
            >
          </div>      
          <div class="col-lg-6 ">
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-box-taped opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    智能繪圖助理平台
                  </h5>                
                  <span class="text-normal  text-info">AI Drawing Platform</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    提供智能園區繪圖模組、智能3D建模模組、智能園區管理助理模組等服務。
                  </li>
                </ul>
              </div>
            </div>             
            <div class="p-3 info-horizontal">
              <div class="d-flex align-items-center mb-2"> 
                <div>
                  <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                    <i
                      class="fas fa-gear-complex-code opacity-10 text-lg"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <div class="ms-3">
                  <h5 class="mb-0">
                    智能繪圖助理訓練平台
                  </h5>                
                  <span class="text-normal  text-info">AI Drawing Training Platform</span>
                </div>  
              </div>
              <div class="description ps-5">
                <ul class="mb-0">
                  <li class="mb-3">
                    提供智能園區繪圖訓練模組、智能3D建模訓練模組、智能園區管理助理訓練模組等訓練AI模型服務。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>




  <!-- -------- START Features w/ 4 infos - just colored icons -------- -->

  <footer class="footer mt-5">
    <div class="container">
      <div class=" row align-items-center">
        <div class="col-md-6 mb-md-4 me-auto">
          <div class="d-none d-md-block">
            <a 
              href="javascript:;"
              @click="goToPage('/')"
            >
              <img
                src="assets/img/logo4.svg"
                class="mb-3"
                style="width: 160px;"
              >
            </a>
          </div>
        </div>

        <div class="col-md-6 mb-md-4 ms-auto text-center text-md-end">
          <a class="mb-3"><img
            src="assets/img/logo4.svg"
            style="width: 160px;"
            class="mb-3 d-md-none"
          ></a>

          <p class="mb-1">
            service@cloudraise.com
          </p>
          <p class="mb-1">
            新北市三重區重新路五段609巷14號5樓之3
          </p>
          <p class="mb-1">
            02-29992891
          </p>
        </div>
        <div class="col-12">
          <div class="text-center">
            <p class="text-dark my-2 my-md-4 text-sm font-weight-normal">
              Copyright ©
              2023
              by Cloud Raise Technology.
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
import { SideNav , Header , ProductHeader , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    SideNav,
    //Header,
    //ProductHeader,
    //NavBar,
    // Settings,
    //Footer,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const nid = ref();

    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);
    /*
    if(router.currentRoute.value.query.nid == null || router.currentRoute.value.query.nid == '' ){
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
    }
	*/
    nid.value= router.currentRoute.value.query.nid ; 

    //console.log('nid' , nid.value);

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;
    function goToPage(page){
      router.push( { path: page } );
    }


    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      nid,
      // function
      goToPage,
      chkLogin,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
